var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from "lit/directives/unsafe-html.js";
import renderOperationPathCss from "./render-operation-path.css.js";
let PathRenderComponent = class PathRenderComponent extends LitElement {
    constructor() {
        super();
        this.path = "/";
        this.nowrap = false;
    }
    replaceBrackets() {
        const regex = /(\{)([\w$.#/]+)(\})/gm;
        let m;
        let returnString = this.formatSlashes(this.path);
        while ((m = regex.exec(this.path)) !== null) {
            // This is necessary to avoid infinite loops with zero-width matches
            if (m.index === regex.lastIndex) {
                regex.lastIndex++;
            }
            m.forEach((match, groupIndex) => {
                if (groupIndex === 1) {
                    returnString = returnString.replaceAll(match, `<span class="bracket ${this.nowrap ? 'nowrap' : ''}">` + match + '</span>');
                }
                if (groupIndex === 2) {
                    returnString = returnString.replaceAll(match, `<span class="param ${this.nowrap ? 'nowrap' : ''}">` + match + '</span>');
                }
                if (groupIndex === 3) {
                    returnString = returnString.replaceAll(match, `<span class="bracket ${this.nowrap ? 'nowrap' : ''}">` + match + '</span>');
                }
            });
        }
        if (!this.nowrap) {
            return html `${unsafeHTML(returnString.toString())}`;
        }
        return html `<div style="white-space: nowrap;">${unsafeHTML(returnString.toString())}</div>`;
    }
    formatSlashes(formatted) {
        return formatted.replaceAll(`/`, `<span class="slash">/</span>`);
    }
    render() {
        return html `${this.replaceBrackets()}`;
    }
};
PathRenderComponent.styles = renderOperationPathCss;
__decorate([
    property()
], PathRenderComponent.prototype, "path", void 0);
__decorate([
    property({ type: Boolean })
], PathRenderComponent.prototype, "nowrap", void 0);
PathRenderComponent = __decorate([
    customElement('pb33f-render-operation-path')
], PathRenderComponent);
export { PathRenderComponent };
